type ConsentSettings = {
  ad_storage: 'granted' | 'denied',
  analytics_storage: 'granted' | 'denied',
  ad_user_data: 'granted' | 'denied',
  ad_personalization: 'granted' | 'denied',
};

/**
 * @description Send Google Consent v2 tag updates
 * @param consent - Consent settings object
 */
export default function sendGoogleConsent(consent: ConsentSettings): void {
  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', consent);
  }
}
